import { render, staticRenderFns } from "./PrepareMedList.vue?vue&type=template&id=3c3a5ed3&scoped=true"
import script from "./PrepareMedList.vue?vue&type=script&lang=js"
export * from "./PrepareMedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a5ed3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3a5ed3')) {
      api.createRecord('3c3a5ed3', component.options)
    } else {
      api.reload('3c3a5ed3', component.options)
    }
    module.hot.accept("./PrepareMedList.vue?vue&type=template&id=3c3a5ed3&scoped=true", function () {
      api.rerender('3c3a5ed3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/PrepareMedList.vue"
export default component.exports